import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface GeoMarker extends SVGProps<SVGSVGElement> {
  label?: string
}

const GeoMarker: React.FC<GeoMarker> = ({
  label = 'geo-marker',
  ...restProps
}) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="geo-marker-svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 19.7733L4.69667 14.47C3.64778 13.4211 2.93348 12.0847 2.6441 10.6299C2.35472 9.17501 2.50325 7.66701 3.07091 6.29657C3.63857 4.92613 4.59987 3.7548 5.83323 2.93069C7.0666 2.10658 8.51664 1.66672 10 1.66672C11.4834 1.66672 12.9334 2.10658 14.1668 2.93069C15.4001 3.7548 16.3614 4.92613 16.9291 6.29657C17.4967 7.66701 17.6453 9.17501 17.3559 10.6299C17.0665 12.0847 16.3522 13.4211 15.3033 14.47L10 19.7733ZM14.125 13.2917C14.9407 12.4758 15.4963 11.4364 15.7213 10.3049C15.9463 9.17334 15.8308 8.00048 15.3892 6.93462C14.9477 5.86875 14.2 4.95774 13.2408 4.31679C12.2815 3.67584 11.1537 3.33374 10 3.33374C8.8463 3.33374 7.71851 3.67584 6.75923 4.31679C5.79996 4.95774 5.05229 5.86875 4.61076 6.93462C4.16923 8.00048 4.05368 9.17334 4.27871 10.3049C4.50374 11.4364 5.05925 12.4758 5.875 13.2917L10 17.4167L14.125 13.2917ZM10 10.8333C9.55797 10.8333 9.13405 10.6577 8.82149 10.3452C8.50893 10.0326 8.33333 9.60868 8.33333 9.16665C8.33333 8.72462 8.50893 8.3007 8.82149 7.98814C9.13405 7.67558 9.55797 7.49999 10 7.49999C10.442 7.49999 10.8659 7.67558 11.1785 7.98814C11.4911 8.3007 11.6667 8.72462 11.6667 9.16665C11.6667 9.60868 11.4911 10.0326 11.1785 10.3452C10.8659 10.6577 10.442 10.8333 10 10.8333Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default GeoMarker
